<template>
    <li @click="goTo" class="criterio-contenedor">
      <v-icon class="icon" color="info">{{ areaIcon }}</v-icon>
      <span class="criterio-item">{{ `${area} > ${subarea} > ${criterio}`}}</span>
    </li>
</template>

<script>
export default {
  props: {
    criterio: String,
    subarea: String,
    area: String,
    subareaId: Number,
    areaIcon: String
  },
  methods: {
    goTo () {
      if (this.$store.getters.isSafRole) {
        this.$router.push({ name: 'fichaClub',
          params: {
            idClub: this.$store.state.fichaId,
            idSubarea: this.subareaId
          }
        })
      } else {
        this.$router.push({ name: 'ficha', params: { id: this.subareaId } })
      }
    }
  }
}

</script>

<style scoped>

li{
  list-style: none;
}
.criterio-item {
    cursor: pointer;
    font-size: 1.4em;
    font-family: SourceSansProRegular, sans-serif;
    color: #354677;
}
.criterio-contenedor {
  cursor: pointer;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
  text-align: left;
}
.criterio-contenedor:hover > span{
  color: #4b69c5;
}
.icon{
  vertical-align: middle;
  padding-right: 10px;
}

li{
  list-style: none;
  border-bottom: 1px solid rgb(214, 202, 202);
}

li:hover{
  background-color: #fbf9f9;
}

</style>
